import { getAdMarketPublishGroupCode } from './getCommonAdProperties';

export const getAdMarketCountryCode = () => {
    const marketPublishGroupCode = getAdMarketPublishGroupCode();
    let countryCode: string;

    if (marketPublishGroupCode) {
        countryCode = marketPublishGroupCode.toUpperCase().split('-')[1];
    }

    return countryCode;
};
